import { render, staticRenderFns } from "./submit.vue?vue&type=template&id=3315d8b2&scoped=true&"
import script from "./submit.vue?vue&type=script&lang=js&"
export * from "./submit.vue?vue&type=script&lang=js&"
import style0 from "./submit.vue?vue&type=style&index=0&id=3315d8b2&prod&scoped=true&lang=css&"
import style1 from "./submit.vue?vue&type=style&index=1&id=3315d8b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3315d8b2",
  null
  
)

export default component.exports